export default __webpack_public_path__ + "static/ballburr-9de6610e0112f487249e93602088e4da.png";